/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

import { useRegisterNavigation } from "hooks/useRegisterNavigation";

export const RegisterLink: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { isExternalRegistration, registrationUrl, registerPath } =
    useRegisterNavigation();

  if (isExternalRegistration && registrationUrl) {
    return (
      <a href={registrationUrl} rel="noreferrer noopener">
        {children}
      </a>
    );
  }

  return <Link to={registerPath}>{children}</Link>;
};
